import { Grid, Container, Box } from '@mui/material';
import { useSearchDirectoryData } from '@/context/searchDirectory/SearchDirectoryDataContext';
import { usePageAttributes } from '@/components/contexts/PageAttributesContext';
import { getHeroImage } from '@/components/feature/searchDirectory/getHeroImage';
import { BackgroundCheckTrustBadge } from '@/components/feature/searchDirectory/BackgroundCheckTrustBadge';
import { getDefaultHeroImageLarge } from '@/helpers/getDefaultHeroImageLarge';
import { HeroConversionBox } from '../HeroConversionBox';

export const HeroSection = () => {
  const pageData = useSearchDirectoryData();
  const {
    seoSegmentationDetails: { serviceId },
  } = pageData;
  const { seoSegmentId } = usePageAttributes();
  const heroImage =
    getHeroImage({ seoSegmentId, serviceId }) ??
    getDefaultHeroImageLarge(pageData.seoSegmentationHeroImage);

  return (
    <Container
      maxWidth="lg"
      sx={{
        mt: { xs: 3, sm: 6, lg: 10 },
        mb: { xs: 6, lg: 8 },
        px: { xl: 0 },
      }}>
      <Grid
        container
        sx={{
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: { sm: 'center' },
        }}>
        <Grid item sm={6}>
          <HeroConversionBox />
          <Box mb={{ xs: 6, sm: 0 }}>
            <BackgroundCheckTrustBadge />
          </Box>
        </Grid>
        {heroImage && (
          <Grid
            item
            sm={6}
            sx={{
              flex: { sm: 1 },
            }}>
            <Box
              component="img"
              src={heroImage}
              alt="Hero image"
              sx={{
                width: '100%',
                objectFit: 'cover',
                pl: { sm: 4, lg: 6 },
              }}
            />
          </Grid>
        )}
      </Grid>
    </Container>
  );
};
